var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXiansuo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 5.3a1.65 1.65 0 100-3.3 1.65 1.65 0 000 3.3zM3.7 13.967a1.65 1.65 0 100-3.3 1.65 1.65 0 000 3.3z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 5.333v6.502A2.157 2.157 0 0110.151 14a2.157 2.157 0 01-2.148-2.165V4.168A2.16 2.16 0 005.85 2 2.16 2.16 0 003.7 4.168v6.499",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xiansuo.c56032f6.svg";
export { SvgTongyongXiansuo as ReactComponent };